
import { Box, useTheme, useMediaQuery } from '@mui/material';
import VillaImage from "../components/IndividualVilla/VillaImage";
import VillaDetails from "../components/IndividualVilla/VillaDetails";
import DetailsOverview from "../components/IndividualVilla/DetailsOverview";
import { useState, useEffect } from "react";
import { investorApi, vendorApi } from "../api/api";
import { useDispatch } from "react-redux";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropertyDocument from "../components/PropertyDetalis/PropertyDocument";
import RecentPropertiesList from "../components/RecentProperties/RecentPropertiesList";
import Loader from "../components/common/Loader";
import ScreenContainer from "../components/common/screencontainer";
import { Helmet } from "react-helmet-async";
const IndividualVillaScreen = () => {
  const { userId, isAuthenticated } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { slug } = useParams();
  const [searchParams] = useSearchParams();

  const propertyIdFromSlug = slug?.split("-").pop();
  const referralCode = searchParams.get("ref");


  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTabletOrLaptop = useMediaQuery(theme.breakpoints.down('md'));
  const [propertyData, setPropertyData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  if (referralCode) {
    const existingRef = localStorage.getItem("referralCode");

    if (!existingRef) {
      localStorage.setItem("referralCode", referralCode);
    }
  }
}, [referralCode]);


 useEffect(() => {
  const applyReferral = async () => {
    const storedRef = localStorage.getItem("referralCode");

    if (!isAuthenticated || !storedRef || !propertyIdFromSlug) return;
    console.log(isAuthenticated,storedRef);

    // Prevent self referral
    if (storedRef == userId) {
      localStorage.removeItem("referralCode");
      return;
    }

    try {
      await vendorApi.addProjectUserMapping({
        userId: userId,
        refererId: storedRef,
        propertyId: propertyIdFromSlug,
      });

      localStorage.removeItem("referralCode");
    } catch (error) {
      console.error("Referral error:", error);
    }
  };

  applyReferral();
}, [isAuthenticated, userId, propertyIdFromSlug]);
    useEffect(() => {
  const fetchDetails = async () => {
    try {
      const response = await investorApi.getIndependentHouseById(propertyIdFromSlug);

      if (response.status === 200) {
        setPropertyData(response.data);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (propertyIdFromSlug) {
    fetchDetails();
  }
}, [propertyIdFromSlug]);
  return (
    <ScreenContainer>
      <Helmet>
  <title>
          {propertyData?.[0]?.PropertyName
            ? `${propertyData?.[0]?.PropertyName} for Sale in ${propertyData?.[0]?.Address} | Villas, Plots & Apartments | JEMINS Builders & Developers Private Limited`
            : "Property Details | JEMINS Builders & Developers Private Limited"}
        </title>

  <meta
    name="description"
    content={
      propertyData[0]?.Description ||
      "Explore luxury independent villas with full details, images, and pricing."
    }
  />

  <meta
    name="keywords"
    content="villa for sale, independent house, luxury villa, real estate"
  />

  {/* Open Graph for social sharing */}
  <meta property="og:title" content={propertyData[0]?.PropertyName || "Villa"} />
  <meta
    property="og:description"
    content={propertyData[0]?.Description || "Villa details and images"}
  />
  <meta
    property="og:image"
    content={propertyData[0]?.Image || ""}
  />
  <meta property="og:type" content="website" />

  {/* Canonical URL */}
  <link
    rel="canonical"
    href={`https://yourdomain.com/villa/${slug}`}
  />
</Helmet>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: isTabletOrLaptop ? 'column' : 'row',
              overflow: 'hidden',
              padding: isTabletOrLaptop ? 1 : 2,
              boxSizing: 'border-box',
            }}
          >
            {/* Left - Images */}
            <Box
              sx={{
                width: isTabletOrLaptop ? '100%' : '60%',
                pr: isTabletOrLaptop ? 0 : 2,
                mb: isTabletOrLaptop ? 2 : 0,
              }}
            >
              <Box
                sx={{
                  height: '100%',
                  borderRadius: 3,
                  overflow: 'hidden',
                }}
              >
                <VillaImage propertyId={parseInt(propertyData[0]?.Pid)} propertyType={parseInt(propertyData[0]?.PropertyType)} property_refferal_code={propertyData[0]?.refferal_code} />
              </Box>
            </Box>

            {/* Right - Details */}
            <Box
              sx={{
                width: isTabletOrLaptop ? '100%' : '40%',
              }}
            >
              <Box
                sx={{
                  height: '100%',
                  borderRadius: 3,
                  border: '1px solid',
                  borderColor: 'divider',
                  overflowY: 'auto',
                }}
              >
                {propertyData && propertyData.length > 0 && (
                  <VillaDetails propertyData={propertyData} />
                )}
              </Box>
            </Box>
          </Box>

          {propertyData && propertyData.length > 0 && (
            <DetailsOverview propertyData={propertyData} />
          )}
          <Box sx={{ marginTop: "20px", textAlign: "start" }}>
            {propertyData[0]?.Status !== 'sale Initiated' &&
              propertyData[0]?.Status !== 'Sold' && (
                <RecentPropertiesList
                  userId={userId}
                  type={propertyData[0]?.PropertyType}
                  propertyId={propertyData[0]?.Pid}
                />
              )}
          </Box>
          {/* {propertyData[0]?.Status === 'sale Initiated' && (
            <PropertyDocument
              data={propertyData[0]?.Pid}
              userId={userId}
              type={propertyData[0]?.PropertyType}
            />
          )} */}
        </>
      )}
    </ScreenContainer>


  );

};
export default IndividualVillaScreen;

